export interface QuantityLimitState {
    quantityLimit: QuantityLimitItem[],
    quantityLimitItem?: QuantityLimitItem
}

export interface QuantityLimitFilter {
    transports?: string,
    templates?: string[],
    message_types?: string[],
    limit?: number
    timeout?: number
}

export class QuantityLimitFilterImpl implements QuantityLimitFilter {
    transports = undefined;
    templates = undefined;
    message_types = undefined;
    limit = undefined;
    timeout = undefined;
}

export interface QuantityLimitItem {
    id?:number,
    transport_ids?: number[],
    template_ids?: number[],
    message_type_ids?: number[],
    limit?: number | null,
    timeout?: number | null,
}

export class QuantityLimitItemImpl implements QuantityLimitItem {
    id?:number;
    transport_ids?: number[];
    template_ids?: number[];
    message_type_ids?: number[];
    limit?: number | null;
    timeout?: number | null;

    constructor() {
        this.transport_ids = [];
        this.template_ids = [];
        this.message_type_ids = [];
        this.limit = null;
        this.timeout = null;
    }
}
